import { slick } from "@accessible360/accessible-slick";

class Media {
    constructor(element) {
        this.el = element;
        if (!this.el || this.el.carousel) return;

        this.init();
    }

    init() {
        this.createCarousel();
    }

    createCarousel() {
        let nav_id = this.el.dataset.mainCarousel
            ? this.el.dataset.mainCarousel
            : this.el.dataset.navCarousel;

        let nav_for = this.el.dataset.mainCarousel
            ? `[data-nav-carousel="${nav_id}"]`
            : `[data-main-carousel="${nav_id}"]`;

        // Find if main carousel has nav carousel linked
        let has_nav = this.el.dataset.mainCarousel
            ? document.querySelector(`[data-nav-carousel="${nav_id}"]`)
            : false;

        const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;

        const props = {
            dots: false,
            arrows: true,  // default true
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrowsPlacement: "afterSlides",
            prevArrow:
                '<button type="button" data-control-prev><span class="sr-text">Previous</span>' +
                arrow +
                "</button>",
            nextArrow:
                '<button type="button" data-control-next><span class="sr-text">Next</span>' +
                arrow +
                "</button>",
        };

        if (this.el.dataset.mainCarousel) {
            // For main carousel, disable arrows if NOT header-carousel
            if (nav_id !== "header-carousel") {
                props.arrows = false;
                // props.infinite = false;
            }
            // Link nav carousel if available
            if (has_nav) {
                props.asNavFor = nav_for;
            }
        }

        if (this.el.dataset.navCarousel) {
            // Nav carousel settings
            props.arrows = true; // Nav always shows arrows
            props.slidesToShow = 8;
            props.instructionsText = `Changing the current slide of this carousel will change 
                the current slide of the preceding main image carousel.`;
            props.regionLabel = "thumbnail carousel";
            props.responsive = [{ breakpoint: 768, settings: { slidesToShow: 3 } }];
            props.slidesToScroll = 1;
            props.infinite = true;

            if (nav_id === "header-carousel") {
                props.slidesToShow = 3;
                // props.infinite = false;
                props.arrows = true;
            }

            props.asNavFor = nav_for;
        }

        let carousel = $(this.el).slick(props);
        this.el.carousel = carousel;

        // Then do events,
        const active_class = "media-item-active";

        if (this.el.dataset.navCarousel) {
            this.el.querySelector(".slick-active").classList.add(active_class);
            const buttons = this.el.querySelectorAll("[data-go-to]");

            buttons.forEach((button) => {
                button.addEventListener("click", () => {
                    const carousel_index = button.dataset.carouselIndex;
                    const slide_index = button.dataset.goTo - 1;

                    $(`[data-nav-carousel="${carousel_index}"]`).slick(
                        "slickGoTo",
                        slide_index,
                    );
                });
            });
        }

        if (has_nav) {
            carousel.on("afterChange", () => {
                let carousel_index = carousel.data("main-carousel"),
                    slide_index = carousel.slick("slickCurrentSlide");

                let active = document.querySelector("." + active_class);
                if (active) active.classList.remove(active_class);

                const navSlide = document.querySelector(
                    `[data-nav-carousel="${carousel_index}"] [data-slick-index="${slide_index}"]`,
                );
                if (navSlide) navSlide.classList.add(active_class);
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const mediaCarousels = document.querySelectorAll(
        "[data-carousel='media'], [data-carousel='media-nav']",
    );

    mediaCarousels.forEach((element) => {
        new Media(element);
    });
});

export default Media;
